import React from 'react'
import './Commentscdmqb.css'
// All classNames are suffixed with "CDMQB" so they never collide with the
// default skin's CSS if that stylesheet happens to be loaded too.

export default function CommentsCDMQB(props) {
    return (
        <div className={`commentsPageWrapperCDMQB ${props.displayCommentsPopup ? '' : 'hideCommentsPopupCDMQB'}`}>
            <div className='commentsBackdropCDMQB' onClick={props.closeComments}/>
            <div className='commentsContainerCDMQB'>
                <div className='commentsHeaderWrapperCDMQB'>
                    <h4 className='commentsHeaderTextCDMQB'>Comments</h4>
                </div>
                <textarea value={props.comments} onChange={props.updateComments} className='commentsTextAreaCDMQB'/>
                <div className='commentsFooterWrapperCDMQB'>
                    <button className='commentsCloseButtonCDMQB'onClick={props.closeComments}>Close</button>
                </div>
            </div>
        </div>
    )
}